import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { LOGO_URL, COMPANY_NAME } from '@/config/brand';
import { Home, ClipboardList, ScanLine, Bell, User, FileText, Palmtree, Package } from 'lucide-react';

const navItems = [
  { path: '/worker', label: 'Home', icon: Home },
  { path: '/worker/rapportini', label: 'Rapportini', icon: ClipboardList },
  { path: '/worker/magazzino', label: 'Magazzino', icon: Package, magazzinierePath: '/admin/magazzino' },
  { path: '/worker/documenti', label: 'Documenti', icon: FileText },
  { path: '/worker/ferie-malattia', label: 'Ferie', icon: Palmtree },
  { path: '/worker/scanner', label: 'Scanner', icon: ScanLine },
  { path: '/worker/notifiche', label: 'Notifiche', icon: Bell },
  { path: '/worker/profilo', label: 'Profilo', icon: User },
];

export default function WorkerLayout({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  const isMagazziniere = user?.role === 'magazziniere' || user?.is_magazziniere === true;

  return (
    <div className="min-h-screen bg-slate-50 pb-[calc(4rem+env(safe-area-inset-bottom))]">
      <header className="sticky top-0 z-40 bg-white border-b border-slate-200 px-4 pb-3 pt-[max(env(safe-area-inset-top),0.75rem)]">
        <div className="max-w-md mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="bg-white rounded-md p-1">
              <img src={LOGO_URL} alt="CR" className="h-7 w-auto object-contain" />
            </div>
            <div>
              <h1 className="font-bold text-slate-900 text-sm leading-tight">{COMPANY_NAME}</h1>
              <p className="text-[10px] text-slate-500">Ciao, {user?.name}</p>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-md mx-auto px-4 py-6">{children}</main>

      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 flex justify-around items-center z-50 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] pb-[env(safe-area-inset-bottom)]">
        {navItems.map((item) => {
          const targetPath = (isMagazziniere && item.magazzinierePath) ? item.magazzinierePath : item.path;
          const isActive = location.pathname === targetPath;
          const Icon = item.icon;
          return (
            <Link key={item.path} to={targetPath} className={`flex flex-col items-center justify-center w-16 h-16 transition-colors ${isActive ? 'text-blue-600' : 'text-slate-400 hover:text-slate-600'}`} data-testid={`worker-nav-${item.label.toLowerCase()}`}>
              <Icon className="h-5 w-5" />
              <span className="text-[10px] mt-1 font-medium">{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
